// 移动端
const MOBILE_BREAKPOINT = 768;

export function isMobile() {
  return window.innerWidth <= MOBILE_BREAKPOINT;
}

export function isPC() {
  return window.innerWidth > MOBILE_BREAKPOINT;
}

// 监听屏幕大小变化
export function onDeviceChange(callback) {
  let resizeTimer;
  const handleResize = () => {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(() => {
      callback(isMobile());
    }, 100);
  };
  
  window.addEventListener('resize', handleResize);
  
  // 返回移除监听器的函数
  return () => {
    window.removeEventListener('resize', handleResize);
  };
} 